// eslint-disable-next-line max-len
// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.

const colors = {
  paletteTrans2: "#e0e0e0",
  paletteTrans1: "#eaeaea",
  paletteTrans0: "#f4f4f4",
  paletteEcharts0: "#5470c6",
  paletteEcharts1: "#91cc75",
  paletteEcharts2: "#fac858",
  paletteEcharts3: "#ee6666",
  paletteEcharts4: "#73c0de",
  paletteEcharts5: "#3ba272",
  paletteEcharts6: "#fc8452",
  paletteEcharts7: "#9a60b4",
  paletteReserved1: "#5e7a83",
  paletteReserved2: "#40798c",
  paletteReserved3: "#70a9a1",
  paletteReserved0: "#1f363d",
  paletteNeutral0: "#cfdaf7",
  paletteNeutral3: "#8f9ed1",
  paletteNeutral2: "#f8f9fd",
  paletteNeutral1: "#e7eafc",
  paletteBlue3: "#31a2ce",
  paletteGreen2: "#c8eede",
  paletteGreen1: "#1f6648",
  paletteGreen0: "#36b37e",
  paletteOrange0: "#ffc107",
  paletteOrange3: "#ff6b00",
  paletteOrange2: "#ffe8ad",
  paletteOrange1: "#9b5a01",
  paletteWhite2: "#e0e0e0",
  paletteWhite3: "#d5d5d5",
  paletteWhite1: "#f7f7f8",
  paletteRed0: "#db5c65",
  paletteRed2: "#ffe2e2",
  paletteRed1: "#a30013",
  paletteWhite0: "#ffffff",
  paletteBlue1: "#0c1457",
  paletteBlack0: "#000000",
  paletteBlack1: "#333333",
  paletteBlue2: "#5c6e9e",
  paletteBlue0: "#0d2976",
  palettePrimaryAction: "#6ef29c",
  palettePrimary0: "#2358f8",
  palettePrimary5: "#436fb6",
  palettePrimary3: "#c5f0fe",
  palettePrimary2: "#4b75ff",
  palettePrimary1: "#1531b8"
} as const;

export default colors;
